const KEY_PRECISION = 9;
function keyNumber(value) {
    if (!Number.isFinite(value)) {
        return String(value);
    }
    const rounded = Number.parseFloat(value.toPrecision(KEY_PRECISION));
    return String(rounded === 0 ? 0 : rounded);
}
function keyNumbers(values) {
    const parts = [];
    for (let index = 0; index < values.length; index++) {
        parts.push(keyNumber(values[index]));
    }
    return parts.join(',');
}
function voxelGridKey(grid, statistic) {
    return [
        statistic,
        keyNumbers(grid.dimensions),
        keyNumbers(grid.spacing),
        keyNumbers(grid.origin),
        keyNumbers(grid.direction),
    ].join('|');
}
function voxelGridsEqual(gridA, gridB, tolerance = 1e-6) {
    if (!gridA || !gridB) {
        return gridA === gridB;
    }
    for (let axis = 0; axis < 3; axis++) {
        if (gridA.dimensions[axis] !== gridB.dimensions[axis]) {
            return false;
        }
        if (Math.abs(gridA.spacing[axis] - gridB.spacing[axis]) > tolerance) {
            return false;
        }
        if (Math.abs(gridA.origin[axis] - gridB.origin[axis]) > tolerance) {
            return false;
        }
    }
    for (let index = 0; index < 9; index++) {
        if (Math.abs(gridA.direction[index] - gridB.direction[index]) > tolerance) {
            return false;
        }
    }
    return true;
}
export { voxelGridKey as default, voxelGridKey, voxelGridsEqual };
